import Vue from 'vue'
import moment from 'moment-timezone'
import { formatDistanceToKilometer, toTitleCase, limitWords, toMetricValue, uniqueArray } from './general'

export const filterArray = (array, filters) => {
  let filteredItems = []
  let uniqueIds = []
  // Check if any filter is selected
  if (!filters.length) {
    // No filter selected, returning all items
    return array
  }

  // Create new array for
  filteredItems = filters.map(({ filter }) => array.filter(item => filter(item))).flat()

  // Get only unique id's for filtered items
  uniqueIds = filteredItems.map(item => item.id).filter((value, index, self) => self.indexOf(value) === index)

  // Return only filtered items
  return array.filter(item => uniqueIds.includes(item.id))
}

Vue.filter('uniqueArray', uniqueArray)

Vue.filter('limitWords', limitWords)

Vue.filter('filterArray', filterArray)

Vue.filter('toMetricValue', toMetricValue)

Vue.filter('formatDate', (date, format) => {
  if (!date) {
    return date
  }

  return moment.utc(date).local().format(format)
})

Vue.filter('thousandSeparator', (value, separator) => {
  return value.replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1${separator}`)
})

Vue.filter('formatDistance', (meters, decimalCount = 2) => {
  try {
    return `${formatDistanceToKilometer(meters, decimalCount)} km`
  } catch (e) {
    console.log(e)
  }
})

Vue.filter('titleCase', toTitleCase)

Vue.filter('formatMoney', (amount, decimalCount = 2, decimal = '.', thousands = ',') => {
  try {
    decimalCount = Math.abs(decimalCount)
    decimalCount = isNaN(decimalCount) ? 2 : decimalCount

    const negativeSign = amount < 0 ? '-' : ''

    const i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString()
    const j = (i.length > 3) ? i.length % 3 : 0

    return negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + thousands) +
      (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : '')
  } catch (e) {
    console.log(e)
  }
})
